import getQueryNames from "@irati/utils/services/apollo/helpers/getQueryNames"
import {gql} from "@irati/utils/gql"
import CustomRewardTransactionFragment from "../fragment/CustomRewardTransaction"

const query = gql`
  query ListAllCustomRewardsTransactionsQuery {
    listAllTransactions {
      ...CustomRewardTransaction
    }
  }

  ${CustomRewardTransactionFragment}
`
export const getAllCustomRewardsTransactionsQueryKey = getQueryNames(query)[0]
export default query
